/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	import View = alm.view.View;
	import SimpleMovingAverage = alm.math.SimpleMovingAverage;
	import Num = alm.util.Num;

	export class RouteHead extends View<THREE.Object3D> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor() {
			super();

			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():THREE.Object3D {
			const view:THREE.Object3D = new THREE.Object3D();

			this.model = null;
			this.loader = new THREE.GLTFLoader();
			this.loader.load(
				'model/human.glb?202004131141',
				(gltf:THREE.GLTF):void => {
					this.model = gltf.scene;
					const scale = 0.2;
					this.model.scale.set(scale, scale, scale);
					this.model.rotation.x = -Math.PI / 2;
					this.model.rotation.z = Math.PI;
					this.model.position.y = 1;

					const color = new THREE.Color(0x222222);
					MaterialUtil.setEmission(this.model, color);

					view.add(gltf.scene);
				},
				(event:ProgressEvent):void => {
				},
				(event:ErrorEvent):void => {
					trace('[RouteHead]', event);
				}
			);

			this.prevPosition = new THREE.Vector3();
			this.currentAngle = new SimpleMovingAverage(30);

			return view;

			/*
			this.texture = new THREE.TextureLoader().load('image/route-head-person.png');
			this.material = new THREE.SpriteMaterial({
				map: this.texture,
				color: 0xffffff,
				transparent: true,
				depthWrite: false
			});
			const view:THREE.Sprite = new THREE.Sprite(this.material);

			this.textureWidth = 56;
			this.textureHeight = 128;

			this.image = jQuery('#head-tracking-point');
			this.threeManager = ThreeManager.getInstance();
			this.screenPosition = new THREE.Vector3();

			return view;
			*/
		}

		protected implReady():void {
		}

		protected implFinalize():void {
		}

		protected implShow(view:THREE.Object3D, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.visible = true;

				// 2D
				//this.image.css('display', 'block');
			});
		}

		protected implHide(view:THREE.Object3D, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.visible = false;

				// 2D
				//this.image.css('display', 'none');
			});
		}

		public updatePosition(position:THREE.Vector3):void {
			const view = this.getView();

			// 3D
			view.position.set(
				position.x,
				position.y,
				position.z,
			);

			const vx = position.x - this.prevPosition.x;
			const vz = position.z - this.prevPosition.z;
			const targetAngle = -Math.atan2(vz, vx) - Math.PI * 0.5;
			const diffAngle = Num.turn(this.currentAngle.value, targetAngle);
			this.currentAngle.add(this.currentAngle.value + diffAngle);
			view.rotation.y = this.currentAngle.value;

			this.prevPosition.copy(position);

			// 2D
			/*
			this.threeManager.project(position, this.screenPosition);
			this.image.css({
				left: this.screenPosition.x,
				top: this.screenPosition.y,
				display: this.screenPosition.z > 1 ? 'none' : 'block',
			});
			*/
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		// 3D
		private loader:THREE.GLTFLoader;
		private model:THREE.Scene;
		private prevPosition:THREE.Vector3;
		private currentAngle:SimpleMovingAverage;

		// 2D
		/*
		private texture:THREE.Texture;
		private material:THREE.SpriteMaterial;

		private textureWidth:number;
		private textureHeight:number;

		private image:JQuery;
		private threeManager:ThreeManager;
		private screenPosition:THREE.Vector3;
		*/
	}
}
